import { EPaymentMethod } from 'features/Sites/types'

export const getConfirmationModalities = (payments: EPaymentMethod[]): [EPaymentMethod[], boolean, boolean] => {
  const specialMethods = [EPaymentMethod.RESERVED, EPaymentMethod.MIXED]
  const canReserveTickets = payments.includes(EPaymentMethod.RESERVED)
  const enableMixedPayments = payments.includes(EPaymentMethod.MIXED)
  const paymentsPayload = payments.filter((payment) => !specialMethods.includes(payment))

  return [paymentsPayload, canReserveTickets, enableMixedPayments]
}
